import React from "react";
import { qpDatatables } from "../utils/misc";
import { push } from 'react-router-redux';
import { toast } from "react-toastify";

const salesConstants = {
    SALES_GETALL_REQUEST: 'SALES_GETALL_REQUEST',
    SALES_GETALL_RESPONSE: 'SALES_GETALL_RESPONSE',
    SALES_GETALLSUB_RESPONSE: 'SALES_GETALLSUB_RESPONSE',
};

const initialState = {
    salesItems: [], salesInfo: [], isLoading: false, pagetype: 'full' };

export const actionCreators = {
    requestSalesGetAll: pagetype => async (dispatch, getState) => {
        dispatch({ type: salesConstants.SALES_GETALL_REQUEST, pagetype });
        const url = `api/Sales/GetSalesData?type=${pagetype}`;

        fetch(url, {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getState().account.user.token
            }
        })
            .then(handleResponse)
            .then(
                result => {
                    for (var it of result.salesList) {
                        if (it.invoiceNumbers.length === 0) {
                            it.invoiceNumbers = <div><span className="badge badge-primary"><i className="fa fa-warning"></i> No Invoice</span></div>
                        } else {
                            it.invoiceNumbers = <div>
                                {
                                    it.invoiceNumbers.map((item, key) =>
                                        <div key={key}><span className={"badge badge-" + (item.statusId === 21 ? "success" : (item.statusId === 22 ? "warning" : "danger"))}># {item.invoiceNumber} {item.statusId === 21 ? "PAID" : (item.statusId === 22 ? "PARTIAL PAID" : "OPEN")} </span>
                                            <br />
                                        </div>
                                    )
                                }
                            </div>;
                        }
                    }
                    if (pagetype === "full") {
                        dispatch({ type: salesConstants.SALES_GETALL_RESPONSE, pagetype: pagetype, salesItems: result.salesList, salesInfo: (result.paymentChart ? result.paymentChart : getState().salesData.salesInfo) });
                    } else {
                        dispatch({ type: salesConstants.SALES_GETALLSUB_RESPONSE, pagetype: pagetype, salesItems: result.salesList });
                    }
                    
                    qpDatatables();
                },
                error => {
                    if (error.status === 401) {
                        dispatch(push('/login'));
                    } else {
                        toast.warn("Error:" + error.error, {
                            position: toast.POSITION.BOTTOM_RIGHT,
                        });
                    }
                }
            );
    }
};

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                return Promise.reject({ status: response.status });
            }
            const error = text;
            return Promise.reject({ status: response.status, error });
        }
        return data;
    });
}

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === salesConstants.SALES_GETALL_REQUEST) {
        return {
            ...state,
            pagetype: action.pagetype,
            isLoading: true,
        };
    }

    if (action.type === salesConstants.SALES_GETALL_RESPONSE) {
        return {
            ...state,
            isLoading: false,
            salesItems: action.salesItems,
            salesInfo: action.salesInfo
        };
    }

    if (action.type === salesConstants.SALES_GETALLSUB_RESPONSE) {
        return {
            ...state,
            isLoading: false,
            salesItems: action.salesItems
        };
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/store/SalesStore.js